module.exports = __webpack_public_path__ + "img/Screenshot_7.e21bb45d.png";